export default __webpack_public_path__ + "static/media/icon-card-mx-apu-hours-limit.8485a70d.svg";